// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-builder__draggable-field{border:1px dashed #c8c6c4;background-color:#fff;border-radius:8px;padding:15px;margin-top:15px}`, "",{"version":3,"sources":["webpack://./src/components/PreviewForm/InputFields/style.scss","webpack://./src/style/variables.scss"],"names":[],"mappings":"AACA,+BACE,yBAAA,CACA,qBCkDM,CDjDN,iBC8KO,CD7KP,YAAA,CACA,eAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
